import useVuelidate from '@vuelidate/core';
import { mapActions, mapState } from 'vuex';

import { SNACKBAR_TYPES } from '@/utils/constants';
import { ERROR_ACCOUNT_NOT_EXIST, ERROR_RECORD_NOT_FOUND } from '@/utils/errorCodeList';
import { numberInputHandler } from '@/utils/helper';
import {
  account as accountRule,
  identification as identificationRule,
  required,
} from '@/utils/validators';

export default {
  name: 'ResetPassword',
  props: {
    open: {
      default: false,
      type: Boolean,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      form: {
        account: '',
        identification: '',
      },
      hasIdentificationParam: false,
    };
  },
  computed: {
    ...mapState('user', {
      sending: ({ sendingResetPwdLink }) => sendingResetPwdLink,
    }),
  },
  methods: {
    ...mapActions('user', {
      sendResetPwdLink: 'SEND_RESET_PASSWORD_LINK',
    }),
    async fillValues() {
      const { identification: id = '' } = this.$route?.query || {};
      const identification = decodeURIComponent(id);
      this.form.identification = Number(identification);
      const valid = await this.v$.form.identification.$validate(identification);

      this.v$.form.identification.$dirty = false;
      this.hasIdentificationParam = valid;
      this.form.identification = valid ? Number(identification) : '';
    },
    async send() {
      const valid = await this.v$.$validate();
      if (!valid) return;

      try {
        await this.sendResetPwdLink(this.form);
        this.$snackbar({
          type: SNACKBAR_TYPES.SUCCESS,
          msg: '已寄送Email通知帳號擁有者。',
        });
        this.close();
      } catch (error) {
        const { message = '', status } = error;
        const errors = [ERROR_ACCOUNT_NOT_EXIST, ERROR_RECORD_NOT_FOUND];
        const msg = errors.includes(status)
          ? '查無此帳號，請檢查統一編號和帳號是否正確。' : `傳送失敗，請稍後再試。${message}`;
        this.$snackbar({ type: SNACKBAR_TYPES.ERROR, msg });
      }
    },
    close() {
      this.form.account = '';
      this.form.identification = '';
      this.v$.$reset();
      this.$emit('close');
    },
    getErrorMsgs(field) {
      return this.v$.form?.[field]?.$errors?.[0]?.$message;
    },
    hasErrorMsgs(field) {
      return this.v$.form?.[field]?.$errors?.length;
    },
    onNumberInputKeydown(event) {
      numberInputHandler(event);
    },
  },
  watch: {
    open: {
      handler(open) {
        if (open) {
          this.fillValues();
          this.$nextTick(() => {
            document.querySelector('#identification-input')
              .addEventListener('keydown', this.onNumberInputKeydown);
          });
        } else {
          document.querySelector('#identification-input')
            .removeEventListener('keydown', this.onNumberInputKeydown);
        }
      },
    },
  },
  validations() {
    return {
      form: {
        account: { required: required('登入帳號'), accountRule },
        identification: {
          required: required('統一編號'),
          identificationRule,
        },
      },
    };
  },
};
